module.exports = __webpack_public_path__ + "static/img/21-3.936be0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/21-3.jpg
// module id = MS+C
// module chunks = 0